import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {Waypoint} from '@model';
import {getLanguageValue} from "@utility";
import {TranslocoService} from "@ngneat/transloco";

@Injectable({providedIn: 'root'})
@Pipe({name: 'waypointNameByWaypointId'})
export class WaypointNameByWaypointIdPipe implements PipeTransform {

  constructor(private translocoService: TranslocoService) {
  }

  transform(waypointId?: string, waypointList?: Waypoint[]): string {
    if (!waypointId || !waypointList || waypointList.length === 0) {
      return '';
    }

    // @ts-ignore
    const waypoint = waypointList.find((w) => w.id == waypointId);

    if (!waypoint) {
      return '';
    }

    return getLanguageValue(waypoint.pointNameHr, waypoint.pointNameEn, waypoint.pointNameIt, waypoint.pointNameSlo, waypoint.pointNameSr, waypoint.pointNameBs, this.translocoService.getActiveLang()) ?? "";
  }
}
